var React = require('react');

function Speaker (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M190 334l-88-73H57v-80h45l88-78v231zM80 238h30l56 47V154l-55 50H80v34zm166 27l-15-17c8-8 13-16 13-24 1-8-4-18-14-28l17-16c14 15 21 30 21 45-1 14-8 28-22 40zm43 46l-17-16c42-45 42-93-1-147l19-14c50 63 50 123-1 177z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M339 346l-18-15c59-67 59-138 0-218l18-14c66 88 66 172 0 247z","key":1}),React.createElement("path",{"fill":"none","d":"M0 0h445v445H0z","key":2})]);
}

Speaker.defaultProps = {"viewBox":"0 0 445 445"};

module.exports = Speaker;

Speaker.default = Speaker;
